<template>
  <v-container fluid class="d-flex justify-center align-center" >
    <v-row justify="center">
      <v-col cols="12" sm="8" md="6" lg="4">
        <v-card color="transparent" flat>
          <v-card-title class="text-h5 font-weight-bold d-flex justify-center" style="color: #616060; margin-bottom: 2rem;">
            Recuperar contraseña
          </v-card-title>


          <v-form>
            <p class="font-weight-bold text-center" style="color: #616060;">
              {{ recoveryMethod === 'email'
                ? 'Captura el email con el que registraste tu cuenta'
                : 'Captura el teléfono con el que registraste tu cuenta' }}
            </p>
            <v-text-field
                hide-details="auto"
                :label="recoveryMethod === 'email' ? 'Correo electrónico' : 'Teléfono'"
                outlined
                solo
                :type="recoveryMethod === 'email' ? 'email' : 'tel'"
                class="mt-4"
                color="main_color"
                :rules="[recoveryMethod === 'email' ? rules.email.valid_email : rules.telefono.valid_phone, rules.email.required]"
                v-model="forgotPwdInput"
            />
            <v-card-actions class="mt-4">
              <v-btn block color="main_color_action" class="white--text" @click="forgotPasswordSend()">
                Enviar
              </v-btn>
            </v-card-actions>

            <!-- Opción para cambiar el método de recuperación -->
            <p class="text-center mt-4" style="cursor: pointer; color: #616060; font-size: 18px" @click="toggleRecoveryMethod">
              ¿Quieres recuperar con otro método?
              <span class="font-weight-black">
                Recuperar por {{ recoveryMethod === 'email' ? 'teléfono' : 'email' }}
              </span>
            </p>

            <!-- Opciones adicionales -->
            <v-card-text class="text-center" style="color: #616060; font-size: 18px; margin-top: 4rem">
              <p>
                ¿Recordaste tu contraseña?
                <span class="font-weight-black" style="cursor: pointer" @click.stop="$router.push({name: 'login'})">
                  Iniciar Sesión
                </span>
              </p>
              <p>
                ¿Aún no tienes una cuenta?
                <span class="font-weight-black" style="cursor: pointer" @click="$router.push({ name: 'register' })">
                  Regístrate
                </span>
              </p>
            </v-card-text>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'RecoverPassword',
  data() {
    return {
      forgotPwdInput: '',
      recoveryMethod: 'email',
      rules: {
        email: {
          required: value => !!value || 'El campo Email es requerido.',
          valid_email: v => /\S+@\S+\.\S+/.test(v) || 'El email no es válido'
        },
        telefono: {
          required: value => !!value || 'El campo Teléfono es requerido.',
          valid_phone: v => /^\d{10}$/.test(v) || 'El número de teléfono debe tener 10 dígitos'
        }
      }
    }
  },
  methods: {
    ...mapActions('account', ['requestForgotPassword']),

    forgotPasswordSend() {
      let urlForm = window.location.origin + this.$router.resolve({name: 'forgot_password'}).href;
      let request = {
        dato: this.forgotPwdInput,
        type: this.recoveryMethod,
        url_form: urlForm
      };

      this.requestForgotPassword(request).then(resp => {
        console.log(resp);
      }).catch(error => {
        console.log(error);
      });
    },

    toggleRecoveryMethod() {
      this.recoveryMethod = this.recoveryMethod === 'email' ? 'telefono' : 'email';
      this.forgotPwdInput = '';
    }
  }
}
</script>
